import isInCountrySelectorDefinition from './is-in-country'
import isAllowedSelectorDefinition from './is-allowed'

export default [isAllowedSelectorDefinition, isInCountrySelectorDefinition]
